<template>
  <VCarouselItem>
    <div class="advice-wrap">
      <div class="advice-text-wrap">
        <div class="advice-title d-flex flex-nowrap justify-space-between align-start">
          <b>{{ itemData.title }}</b>
          <!--          <img v-if="itemData.image" :src="itemData.image" class="d-md-none advice-image align-self-baseline" />-->
        </div>
        <div class="advice-text">
          {{ itemData.text }}
        </div>
      </div>
      <img
        v-if="itemData.image"
        :src="itemData.image"
        class="advice-image align-self-baseline"
      />
    </div>
    <slot />
  </VCarouselItem>
</template>

<script>
export default {
  name: 'DashboardAdviceItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup({ item }) {
    return {
      itemData: {
        ...item,
        // eslint-disable-next-line global-require,import/no-dynamic-require
        image: item.image ? require(`@/assets/img/${item.image}`) : null,
      },
    };
  },
};
</script>

<style lang="scss">
  .advice-wrap {
    color: rgba(0, 0, 0, 0.87);
  }
</style>

<style scoped lang="scss">
.advice-wrap {
  display: flex;
  justify-content: space-between;
}
.advice-title {
  max-width: 25rem;
  font-size: 1.125rem;
  margin-bottom: 0.875rem;
  color: rgba(0, 0, 0, 0.87);
}
.advice-text {
  max-width: 25rem;
  line-height: 1.375;
  color: rgba(0, 0, 0, 0.87);
}
.advice-image {
  min-width: 8.75rem;
}
@media screen and (max-width: 760px) {
  .advice-title {
    font-size: 1rem;
    line-height: 1.25;
    margin-bottom: 0.625rem;
  }
  .advice-image {
    min-width: 7rem;
    padding-left: 0.5rem;
  }
  .advice-text {
    font-size: 0.875rem;
    line-height: 1.43;
  }
}
</style>
